const DENIAL_PREFIX = 'You do not have access to ';
const DENIAL_SUFFIX = '. Reach out to your Revelio representative for access';

export const assistantAccessDeniedMessage = (featureLabel: string): string =>
  `${DENIAL_PREFIX}${featureLabel}${DENIAL_SUFFIX}.`;

/** Recognize our machine-authored denial inside a tool error, never user intent. */
export const isAssistantAccessDeniedResult = (content: string): boolean => {
  if (!content.startsWith('ERROR:')) return false;
  const start = content.indexOf(DENIAL_PREFIX);
  if (start < 0) return false;
  const labelStart = start + DENIAL_PREFIX.length;
  const end = content.indexOf(DENIAL_SUFFIX, labelStart);
  return end > labelStart && !content.slice(labelStart, end).includes('\n');
};
